import React from 'react'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TabsMui from '../../../layout/TabsMui'
import RbacRoleDetailTab from '../pages/RbacRoleDetailTab'
import RbacRoleHistoryTab from '../pages/RbacRoleHistoryTab'
import RbacRolePermissionsTab from '../pages/RbacRolePermissionsTab'
import RbacRoleUsersTab from '../pages/RbacRoleUsersTab'
import {
  RBAC_ROLE_DETAIL_TAB_VALUE,
  RBAC_ROLE_DETAIL_TEXTS,
  RBAC_ROLE_HISTORY_TAB_VALUE,
  RBAC_ROLE_PERMISSIONS_TAB_VALUE,
  RBAC_ROLE_USERS_TAB_VALUE
} from '../shared/rbacRoleDetailConstants'
import { RBAC_ROLE_DETAIL_TABS } from '../shared/rbacRoleDetailHelpers'

export default function RbacRoleDetailContent({
  error,
  role,
  catalog,
  canManage,
  canManageUsers,
  activeTab,
  isAdmin,
  usersRows,
  usersLoading,
  usersPagination,
  userActionMenuAnchorEl,
  userActionMenu,
  historyRows,
  historyLoading,
  historyPagination,
  onDismissError,
  onBack,
  onTabChange,
  onEditRole,
  onStatusAction,
  onAddUsers,
  onUserRowClick,
  onOpenUserActionMenu,
  onCloseUserActionMenu,
  onUserActionMenuExited,
  onReassignUserAction,
  onViewUserAction,
  onUsersPageChange,
  onUsersRowsPerPageChange,
  onHistoryPageChange,
  onHistoryRowsPerPageChange
}) {
  return (
    <div className="index-table">
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={onDismissError}>
          {error}
        </Alert>
      )}

      <div className="show-area">
        {!role ? (
          <Box>
            <Alert severity="error" sx={{ mb: 2 }}>
              {error || RBAC_ROLE_DETAIL_TEXTS.notFound}
            </Alert>
            <Button variant="outlined" onClick={onBack}>
              {RBAC_ROLE_DETAIL_TEXTS.backToRolesLabel}
            </Button>
          </Box>
        ) : (
          <>
            <div className="show-area-tabs-header">
              <TabsMui
                tabs={RBAC_ROLE_DETAIL_TABS}
                activeTab={activeTab}
                onChange={onTabChange}
                showDivider={false}
                marginBottom={0}
              />
            </div>

            <div className="tab-content-area">
              {activeTab === RBAC_ROLE_DETAIL_TAB_VALUE && (
                <RbacRoleDetailTab
                  role={role}
                  canManage={canManage}
                  onEditRole={onEditRole}
                  onStatusAction={onStatusAction}
                />
              )}

              {activeTab === RBAC_ROLE_PERMISSIONS_TAB_VALUE && (
                <RbacRolePermissionsTab
                  role={role}
                  catalog={catalog}
                  canManage={canManage}
                  onEditRole={onEditRole}
                />
              )}

              {activeTab === RBAC_ROLE_USERS_TAB_VALUE && (
                <RbacRoleUsersTab
                  role={role}
                  rows={usersRows}
                  loading={usersLoading}
                  pagination={usersPagination}
                  canManageUsers={canManageUsers}
                  isAdmin={isAdmin}
                  actionMenuAnchorEl={userActionMenuAnchorEl}
                  actionMenuUser={userActionMenu}
                  onAddUsers={onAddUsers}
                  onUserRowClick={onUserRowClick}
                  onOpenActionMenu={onOpenUserActionMenu}
                  onCloseActionMenu={onCloseUserActionMenu}
                  onActionMenuExited={onUserActionMenuExited}
                  onAssignAction={onReassignUserAction}
                  onViewAction={onViewUserAction}
                  onPageChange={onUsersPageChange}
                  onRowsPerPageChange={onUsersRowsPerPageChange}
                />
              )}

              {activeTab === RBAC_ROLE_HISTORY_TAB_VALUE && (
                <RbacRoleHistoryTab
                  rows={historyRows}
                  loading={historyLoading}
                  pagination={historyPagination}
                  onPageChange={onHistoryPageChange}
                  onRowsPerPageChange={onHistoryRowsPerPageChange}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
